/**
 * Site desenvolvido para divulgação das especializações de odontologia
 *
 * @version 1.0.0
 * @author [Renato Alves](https://github.com/renatociqueira)
 */

import React from "react";
import Layoutcursos from "../../Layout/Cursoslayout";


const Implantodontia = () => {

    return(
        <>
            <Layoutcursos>       
            </Layoutcursos>
            <img src="/images/professores/albertocosta.png" className="img-endodontia" alt="professor"></img>
                <div className="conteudopublico">
                    <p> CIRURGIÕES-DENTISTAS </p>
                </div>
                <div className="conteudodiferenciais">
                    <p> - FLUXO DIGITAL COMPLETO, COM SCANNER INTRA-ORAL E IMPRESSÃO 3D <br/>
                            - CREDENCIAMENTOS EM: CIRURGIA GUIADA, IMPLANTES ZIGOMÁTICOS, AGREGADOS PLAQUETÁRIOS AUTÓLOGOS <br/>
                            - TOMÓGRAFO CONE-BEAM E PLANEJAMENTO VIRTUAL <br/>
                            - AULAS COM PROFESSORES DO BRASIL E OUTROS PAÍSES DO MUNDO
                            </p>
                    
                </div>
                <div className="professor">
                    <p id="prof">PROFª.</p><br/>
                    <strong id="coordenacao">Alberto Costa Gurgel</strong><br/><br/>
                    <p className="curriculo">Formado em Odontologia pela UnP, Especialista com Residência em Cirurgia e 
                                                    Traumatologia Bucomaxilofaciais (Hospital Paulistano/ Santa Paula/ SP) e Implantodontia (CIODONTO/MG)
                                                    , Mestre em Implantodontia (ILAPEO/ PR). Atua como docente do Curso de Odontologia do UNIFACEX e possui 
                                                    grande experiência profissional nessas áreas e no ensino odontológico da graduação e da pós-graduação. 
                                                    Foi Membro Fundador como Professor Presidente Orientador da Liga Acadêmica de Implantodontia do RN. É sócio/diretor da 
                                                    Implant Academy e atua ativamente como palestrante (speaker) da Neodent, membro do Straumann Group. Ainda faz parte do 
                                                    International Team for Implantology - ITI - como membro ativo.</p>

                    <br/> <div className="convidados">
                    <strong>CONVIDADOS</strong><br/>                                
                    <details>
                        <small>
                            BRUNO SÁ - VITÓRIA/ES <br/>
                            EDUARDO BORTOLAS - SANTA MARIA/RS <br/>
                            PAULO HERBST - MAFRA/SC <br/>
                            LUIZ HENRIQUE CHAVES - CURITIBA/PR <br/>
                            DANIEL FARINHA - RECIFE/PE <br/>
                            KELLY CRISTINA - PONTA GROSSA/PR <br/>
                            NADEEM ZAFAR - INGLATERRA <br/>
                            ALEX TAHALANI - INGLATERRA <br/>
                            ARANTZA RODRIGUEZ - ESPANHA <br/>
                            MANUEL CUETO - ARGENTINA
                        </small>
                    </details>
                    </div><br/>
                    <div className="professores">
                        <strong>PROFESSORES</strong><br/>                                
                        <details>
                            {/* <summary> PROFESSORES </summary> */}
                            <small>
                                FERNANDO JOSÉ DE OLIVEIRA NÓBREGA<br/>
                                GENTIL HOMEM DE ARAÚJO NETO <br/>
                            </small>
                        </details><br/><br/> 
                    </div> 

                </div>
                <div id="tipodepagamento">
                    <p className="encontro-conteudo">MENSALMENTE | QUARTA A SÁBADO</p>
                    {/* <small className="encontro-horarios">8H ÀS 12H E DAS 13H30 DAS 17H30</small> */}
                    <p className="cargahoraria-conteudo">1000 HORAS</p>
                    <p className="tipoaula-conteudo">PRESENCIAL </p>
                    <p className="parcelas">24X</p>
                    <p className="R">R$</p>
                    <h1 className="valor">1.600,00</h1>
                    <p className="pagamento-info">PAGAMENTO NO CARTÃO OU NO BOLETO ATÉ A DATA DO VENCIMENTO</p>
                </div>
                <div>
                    <strong className="titulo-curso">ESPECIALIZAÇÃO EM IMPLANTODONTIA</strong>   
                </div>
                <div className="conteudo-curso">
                    <p>
                    A especialidade de IMPLANTODONTIA visa oferecer aos pacientes, a renovação de sua integridade funcional e estética, através da instalação de implantes dentários e reabilitação oral. 
                    Atualmente é uma das áreas de maior desenvolvimento em técnicas operatórias e tecnologia, aliando sempre o conhecimento científico às novidades existentes no mundo odontológico. 
                    O aluno da nossa ESPECIALIZAÇÃO EM IMPLANTODONTIA, terá a oportunidade de desenvolver-se nos mais diversos níveis, dos casos mais simples às técnicas cirúrgicas avançadas. Contamos com um fluxo digital completo, que permite desde a aplicação de um prontuário digital, planejamento dos casos em softwares de última geração, até a finalização dos casos nos melhores laboratórios do país. Todos os exames de imagem, como tomografias de feixe-cônico, serão adquiridos na própria instituição, permitindo ao aluno a experiência de estar em uma central de imagens digitais. Além disso, a nossa filosofia envolve todos os conceitos de CARGA IMEDIATA, REGENERAÇÕES TECIDUAIS, CIRURGIA GUIADA, ARCOS TOTAIS, ESCANEAMENTO INTRA-ORAL, IMPRESSÃO 3D, CAD/CAM, IMPLANTES DE ZIRCÔNIA, entre muitas outras oportunidades de conhecimento e crescimento.
                    Venha viver uma nova IMPLANTODONTIA, onde você é o profissional que o seu paciente precisa.
                    </p>
                </div>
                <a href={`${process.env.PUBLIC_URL}/Files/pdf/Matriz-Implantodontia.pdf`} rel="noreferrer" target='_blank' download><button className="Matriz" ><h4>MATRIZ CURRICULAR</h4></button></a>
     
        </>
    )
};

export default Implantodontia;